// The ISO country code defined by ISO-3166
export const US = 'US';
